/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ACCOUNT_ACTIVATION = 'account-activation',
  APPLICATION = 'application',
  COMPOSED_CHART = 'composed-chart',
  COOKIES_POLICY = 'cookies-policy',
  CUSTOM_ROUTE = 'custom-route',
  CUSTOMER_USER_ITEM = 'customer-user-item',
  CUSTOMER_USER_LIST = 'customer-user-list',
  DASHBOARD = 'dashboard',
  DOWNLOAD_MODAL = 'download-modal',
  FILES_LIST = 'files-list',
  FORGOT_PASSWORD = 'forgot-password',
  GENERATED_OS = 'generated-os',
  INACTIVITY = 'inactivity',
  LOGIN = 'login',
  MESSAGE_ITEM = 'message-item',
  MESSAGE_LIST = 'message-list',
  OPENED_OS = 'opened-os',
  PRODUCT_MANUAL = 'product-manual',
  RESOLUTION_TIME = 'resolution-time',
  ROOT = 'root',
  SETTINGS = 'settings',
  SLA_FILE_LIST = 'sla-file-list',
  SLA_GRAPHIC = 'sla-graphic',
  SLA_OS_LIST = 'sla-os-list',
  TERM_USE = 'term-use',
  USER_ITEM = 'user-item',
  VERSION_FILE_LIST = 'version-file-list',
  VERSION_LIST = 'version-list',
}
export { FragmentNames };
